import { FormControlLabel as MuiFormControlLabel, Popover } from '@material-ui/core';
import styled from 'styled-components';

export const ScrollableContainer = styled.div<{ $height?: string }>`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: ${({ $height }) => $height || '300px'};
  width: 100%;
  padding: 8px;
  border-radius: 8px;
  margin: 0;
  gap: 5px;
  min-width: 200px;
`;

export const ChangeableContainer = styled.div<{ hasError?: boolean }>`
  padding: 4px;
  display: flex;
  width: 320px;
  justify-content: space-between;
  align-items: center;
  border: 1px solid
    ${({ theme, hasError }) =>
      hasError ? theme.palette.error.main : theme.splitcPalette.neutral[7]};
  border-radius: 4px;
  background: ${({ theme }) => theme.splitcPalette.neutral[10]};
`;

export const ContainerHelperText = styled.span`
  color: ${({ theme }) => theme.palette.error.main};
  font-size: 0.75rem;
  margin-left: 12px;
`;

export const FormControlLabel = styled(MuiFormControlLabel)`
  > span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 14rem;
  }
`;

export const PopoverContainer = styled(Popover)`
  .grid-label {
    position: relative;
  }

  .badge-restore {
    position: absolute;
    right: 5%;
  }
`;
